import { ShieldCheck, GraduationCap, Users, BookOpen } from "lucide-react";
import { useEffect, useState } from "react";
import { api } from "../../lib/api";

const items = [
  {
    icon: ShieldCheck,
    title: "Registered Trust",
    desc: "Government registered educational institution providing authentic certifications.",
    span: "md:col-span-4",
    accent: false,
  },
  {
    icon: GraduationCap,
    title: "Professional Courses",
    desc: "Industry-relevant computer courses including DCA, ADCA, PGDCA and more.",
    span: "md:col-span-4",
    accent: false,
  },
  {
    icon: BookOpen,
    title: "Quality Education",
    desc: "Experienced faculty and modern curriculum for skill development.",
    span: "md:col-span-4",
    accent: false,
  },
  {
    icon: Users,
    title: "700++ Students",
    desc: "Successfully trained and certified students since 2009. Building the workforce of tomorrow, one learner at a time.",
    span: "md:col-span-12",
    accent: true,
  },
];

export default function WhyChooseUs() {
  const [affs, setAffs] = useState([]);
  useEffect(() => {
    api.get("/affiliations").then((r) => setAffs(r.data)).catch(() => {});
  }, []);

  return (
    <section className="py-24 bg-[#F2EFEB]" data-testid="why-choose-us-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-10">
          <div className="overline text-[#E07A5F]">Why Choose Us</div>
          <h2 className="font-serif-display text-4xl sm:text-5xl text-[#1B4332] mt-3 leading-tight">
            Excellence in Computer Education
          </h2>
          <p className="mt-4 text-[#5C6661] leading-relaxed">
            A trusted institution rooted in Digboi, Assam — committed to producing
            confident, capable skilled Professional ready for the modern workplace.
          </p>
        </div>

        {affs.length > 0 && (
          <div className="mb-12 flex flex-wrap items-center gap-3" data-testid="why-trust-badges">
            <span className="text-[10px] uppercase tracking-widest text-[#5C6661] font-semibold">Trusted &amp; Recognised</span>
            {affs.map((a) => (
              <div key={a.id} className="inline-flex items-center gap-2 bg-white border border-border rounded-full px-3 py-1.5">
                <img src={a.logo} alt={a.name} className="w-6 h-6 object-contain" />
                <span className="text-xs font-semibold text-[#1B4332]">{a.short_name || a.name}</span>
              </div>
            ))}
          </div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-12 gap-5" data-testid="why-choose-us-grid">
          {items.map((it, idx) => {
            const Icon = it.icon;
            const isAccent = it.accent;
            return (
              <div
                key={it.title}
                className={`${it.span} group relative rounded-2xl p-8 transition-all hover:-translate-y-1 ${
                  isAccent
                    ? "bg-[#1B4332] text-white"
                    : "bg-white border border-border hover:border-[#E07A5F]/40"
                }`}
                data-testid={`why-card-${idx}`}
              >
                <div
                  className={`w-12 h-12 rounded-xl flex items-center justify-center mb-5 ${
                    isAccent ? "bg-[#E07A5F]" : "bg-[#1B4332]/10 text-[#1B4332]"
                  }`}
                >
                  <Icon className={`w-6 h-6 ${isAccent ? "text-white" : ""}`} />
                </div>
                <h3
                  className={`font-serif-display text-2xl ${
                    isAccent ? "text-white" : "text-[#1B4332]"
                  }`}
                >
                  {it.title}
                </h3>
                <p
                  className={`mt-2 text-sm leading-relaxed ${
                    isAccent ? "text-stone-200" : "text-[#5C6661]"
                  }`}
                >
                  {it.desc}
                </p>
                {isAccent && (
                  <div className="mt-6 flex flex-wrap gap-8 pt-6 border-t border-white/15">
                    <div>
                      <div className="font-serif-display text-4xl">700+</div>
                      <div className="text-xs text-stone-300 tracking-widest uppercase mt-1">Certified Students</div>
                    </div>
                    <div>
                      <div className="font-serif-display text-4xl">15+</div>
                      <div className="text-xs text-stone-300 tracking-widest uppercase mt-1">Years of Trust</div>
                    </div>
                    <div>
                      <div className="font-serif-display text-4xl">100%</div>
                      <div className="text-xs text-stone-300 tracking-widest uppercase mt-1">Govt. Recognised</div>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
